// extracted by mini-css-extract-plugin
module.exports = {"text":"SubscriberBankAccountsDetails_text__4GmN5","tooltip":"SubscriberBankAccountsDetails_tooltip__2zlWx"};